<main *ngIf="content">
  <eds-banner-standard
    edsSpacing="xl"
    [breadcrumbItems]="breadcrumbItems"
    [theme]="'primary'"
    [preTitle]="content.preTitle"
    [title]="content.title"
    [subTitle]="content.summary?.value"
    [imageSrc]="content.bannerImage"
    [hasRibbon]="true"
  ></eds-banner-standard>

  <div edsGrid>
    <div class="container container--wide">
      <div edsRow edsSpacing="xl">
        <div edsCol edsSpacing="xl" [columnNumbers]="{ s: 4, m: 6, l: 7 }">
          <!-- Content Blocks -->
          <ng-container
            *ngTemplateOutlet="
              contentBlocks;
              context: { blocks: content.content }
            "
          ></ng-container>
          <!-- Article Listing -->
          <ft-insights-library
            [hideSidebars]="true"
            [externalTranslationLabel]="translationLabels"
            [hideLibraryHeader]="true"
            [preFilter]="content.articleFilters"
          ></ft-insights-library>
        </div>

        <div edsCol [columnNumbers]="{ s: 4, m: 6, l: 3 }">
          <!-- Right Rail Content -->
          <ng-container
            *ngTemplateOutlet="
              contentBlocks;
              context: { blocks: content.rightRail }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </div>
</main>

<!--Reusable template for content blocks -->
<ng-template let-blocks="blocks" #contentBlocks>
  <ng-container *ngFor="let content of blocks" [ngSwitch]="content.contentType">
    <ng-template ngSwitchCase="ftcore:TitleBlock">
      <ft-title-block [content]="content" [isTwoCol]="true"></ft-title-block>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:IntroBlock">
      <ft-text-block [content]="content" [isTwoCol]="true"></ft-text-block>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:ParagraphBlock">
      <ft-text-block [content]="content" [isTwoCol]="true"></ft-text-block>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:LocalizableCardCompund">
      <div
        edsSpacing="md"
        [edsSubGrid]="
          content?.cardCompound?.length > 1 ? 'layout-1' : ' layout-0'
        "
      >
        <eds-promo-card
          *ngFor="let card of content?.cardCompound; let i = index"
          [title]="card.title"
          [subTitle]="card.content"
          [promoImageSrc]="card.image"
          [linkBtnHref]="card.href"
          [theme]="i === 0 ? 'primary' : 'secondary'"
          [hasThumbnail]="true"
        ></eds-promo-card>
      </div>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:Avatar">
      <ft-avatar-block
        [isTwoCol]="true"
        [content]="content"
        [page]="page"
      ></ft-avatar-block>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:Blockquote">
      <ft-blockquote-block
        [content]="content"
        [isTwoCol]="true"
      ></ft-blockquote-block>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:EmbeddedVideo">
      <eds-video edsSpacing="md" [embedScript]="content.videoEmbedCode">
      </eds-video>
    </ng-template>
    <ng-template ngSwitchCase="ftcore:EmbeddedAudio">
      <div [innerHTML]="content.audioEmbedCode | safeHtml"></div>
    </ng-template>
  </ng-container>
</ng-template>
